import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";
import { InvoiceDTO } from "../../schema/Invoice/InvoiceDTO";
import { InvoiceFiltersDTO } from "../../schema/Invoice/InvoiceFiltersDTO";

@Injectable({
    providedIn: "root"
})
export class ApiInvoiceService {
    private relativePath: string;

    constructor(private httpClient: HttpClient) {
        this.relativePath = `${environment.fiscal.url}/api/v1/Invoice`;
    }

    public GetList(filters: InvoiceFiltersDTO): Observable<GetDataDTO<InvoiceDTO>> {
        var params: HttpParams = new HttpParams()
            .set("skip", filters.skip.toString())
            .set("take", filters.take.toString());

        if (filters.status != null) params = params.set("status", filters.status.toString());
        if (filters.environment != null) params = params.set("environment", filters.environment.toString());
        if (filters.find != null) params = params.set("find", filters.find);
        if (filters.billId != null) params = params.set("billId", filters.billId);

        return this.httpClient.get<GetDataDTO<InvoiceDTO>>(`${this.relativePath}`, { params: params });
    }

    GetPdf(invoiceId: string): Observable<Blob> {
        return this.httpClient.get(`${this.relativePath}/${invoiceId}/pdf`, {
            headers: { "Access-Control-Allow-Origin": "*" },
            responseType: "blob"
        });
    }
}
